import React from 'react'

const Loading = ({title}) => {
  return (
    <div className="flex flex-col items-center justify-center h-[90vh] bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Animated molecules/atoms */}
      <div className="relative mb-8">
        {/* Central nucleus */}
        <div className="w-4 h-4 bg-blue-600 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        {/* Orbiting electrons */}
        <div className="w-20 h-20 border-2 border-blue-300 rounded-full animate-spin">
          <div className="w-3 h-3 bg-blue-500 rounded-full absolute -top-1.5 left-1/2 transform -translate-x-1/2"></div>
        </div>
        
        <div className="w-16 h-16 border-2 border-green-300 rounded-full animate-spin absolute top-2 left-2" style={{animationDirection: 'reverse', animationDuration: '2s'}}>
          <div className="w-2.5 h-2.5 bg-green-500 rounded-full absolute -top-1 left-1/2 transform -translate-x-1/2"></div>
        </div>
        
        <div className="w-12 h-12 border-2 border-purple-300 rounded-full animate-spin absolute top-4 left-4" style={{animationDuration: '1.5s'}}>
          <div className="w-2 h-2 bg-purple-500 rounded-full absolute -top-1 left-1/2 transform -translate-x-1/2"></div>
        </div>
      </div>
      
      {/* Brand name with typing effect */}
      <div className="text-center">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
          LifeChemist
        </h1>
        <div className="flex items-center justify-center gap-1">
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
          <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
        </div>
        <p className="text-slate-600 mt-3 text-sm animate-pulse">
          {title || "Loading Data..."}
        </p>
      </div>
      
      
      
      {/* Custom keyframes for progress animation */}
      <style jsx>{`
        @keyframes progress {
          0% {
            width: 0%;
            opacity: 0.5;
          }
          50% {
            width: 70%;
            opacity: 1;
          }
          100% {
            width: 100%;
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  )
}

export default Loading